import { alertClasses, buttonBaseClasses, svgIconClasses } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useAlertStyles = makeStyles()(theme => ({
  root: {
    [`& > .${alertClasses.action}`]: {
      paddingTop: 0,
      marginRight: theme.spacing(-1),

      [`& > .${buttonBaseClasses.root}`]: {
        padding: 0,
        height: 24,
        width: 24,

        [`& > .${svgIconClasses.root}`]: {
          height: 24,
          width: 24,
          color: theme.palette.grey[900],
        },

        borderRadius: '50%',
        backgroundColor: 'unset',
        border: 'none',

        '&:hover': {
          border: 'none',
        },
      },
    },
  },
  inlineRoot: {
    [`& > .${alertClasses.icon}`]: {
      marginTop: theme.spacing(1),
    },
    [`& > .${alertClasses.action}`]: {
      marginTop: theme.spacing(1),
    },
  },
  inlineChildren: {
    marginTop: theme.spacing(1),
  },
  buttonsWrapper: {
    marginTop: theme.spacing(4),
    display: 'flex',
    gap: theme.spacing(2),
  },
  childrenWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },
  secondaryButton: {
    color: theme.palette.text.secondary,
  },
}));
